"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyDateRangeWindow_1 = require("../applyDateRangeWindow");
var core_1 = require("../core");
exports.customDateWindow = function (range, accessor) {
    return function (table) { return applyDateRangeWindow_1.applyDateRangeWindow(table, range, accessor); };
};
exports.createCustomWindow = function (range) {
    return {
        type: core_1.DateWindowTypes.CUSTOM,
        range: range,
    };
};
//# sourceMappingURL=customDateWindow.js.map